<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.type"
              placeholder="工作任务分类"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.provinceName"
              placeholder="省区"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.cityName"
              placeholder="城市"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.name"
              placeholder="任务名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.status"
              placeholder="状态"
              clearable
              style="width:100%"
            >
              <el-option
                label="草稿"
                value="1"
              />
              <el-option
                label="发布"
                value="2"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="handleAdd"
        @edit="handleEdit(arguments)"
        @release="handleRelease(arguments)"
        @revoke="handleRevoke(arguments)"
        @delete="handleDelete(arguments)"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      dialog-title="查看"
      :dialog-visible.sync="dialogViewVisible"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditDialog from './components/addEditDialog'
// 查看
import viewDialog from './components/viewDialog'
// 终端走访配置动作API
import { loadTerminalVisitConfigActionListDataApi, exportTerminalVisitConfigActionListDataApi, updateStatusTerminalVisitConfigActionApi, deleteTerminalVisitConfigActionApi } from '@/api/v2/terminalVisitConfigAction'

export default {
  name: 'TerminalVisitConfigActionView',
  components: { CustomTable2, TableOperation2, addEditDialog, viewDialog },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data() {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'terminal_visit_config_action_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['terminal_visit_config_action_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['terminal_visit_config_action_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['terminal_visit_config_action_release'],
            prop: 'release',
            label: '发布',
            method: 'release'
          },
          {
            permissionSigns: ['terminal_visit_config_action_revoke'],
            prop: 'revoke',
            label: '撤销',
            method: 'revoke'
          },
          {
            permissionSigns: ['terminal_visit_config_action_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['terminal_visit_config_action_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['terminal_visit_config_action_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          type: '',
          provinceName: '',
          cityName: '',
          name: '',
          status: ''
        },
      },
      typeOptions: [
        { label: '客情维护', value: 1 },
        { label: '终端宣传', value: 2 },
        { label: '品牌推广', value: 3 },
        { label: '经营指导', value: 4 },
        { label: '终端调研', value: 5 },
        { label: '资料采集', value: 6 },
      ],
      id: null,
      eventType: '',
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      dialogViewVisible: false,
    }
  },
  created() {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'typeValue', label: '任务分类', filterColumn: 'type', filterValue: 'type', filterArray: _this.typeOptions, width: 110 },
      { prop: 'name', label: '任务名称', width: 240 },
      { prop: 'provinceName', label: '省区', width: 120 },
      { prop: 'cityName', label: '城市', width: 120 },
      { prop: 'terminalTypeValue', label: '适用终端', filterColumn: "REPLACE(REPLACE(REPLACE(REPLACE(terminal_type, '1', '重点终端'), '2', '潜力终端'), '3', '信息采集终端'), ',', ' / ')", width: 230 },
      { prop: 'actionRequireValue', label: '任务要求', filterColumn: 'action_require', filterValue: 'actionRequire', filterArray: [{ label: '照片', value: 1 }, { label: '调研问题', value: 2 }], width: 110 },
      { prop: 'imageNum', label: '照片数量', width: 110 },
      { prop: 'questionNum', label: '问题数量', width: 110 },
      { prop: 'description', label: '工作任务规定详细说明', minWidth: 300 },
      { prop: 'isDefaultValue', label: '默认', filterColumn: 'is_default', filterValue: 'isDefault', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 80 },
      { prop: 'statusValue', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '草稿', value: 1 }, { label: '发布', value: 2 }], width: 80 },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this;
      loadTerminalVisitConfigActionListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 新增
    handleAdd() {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditTitle = '新增'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 修改
    handleEdit(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的工作任务', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '工作任务不在草稿状态，不能修改', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditTitle = '修改'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    handleView(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的工作任务', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 发布
    handleRelease(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要发布的工作任务', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '工作任务不在草稿状态，不能发布', type: 'warning' })
        return
      }
      _this.$confirm('是否确定发布该工作任务？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStatusTerminalVisitConfigActionApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '发布成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 撤销
    handleRevoke(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要撤销发布的工作任务', type: 'warning' })
        return
      } else if (args[0].status !== 2) {
        _this.$message({ message: '工作任务不在发布状态，不能撤销', type: 'warning' })
        return
      }
      _this.$confirm('是否确定撤销发布该工作任务？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStatusTerminalVisitConfigActionApi({ id: args[0].id, status: 1 }).then(() => {
          _this.$message({ message: '撤销成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 作废
    handleDelete(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的工作任务', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '工作任务不在草稿状态，不能作废', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该工作任务？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteTerminalVisitConfigActionApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage() {
      let _this = this;
      exportTerminalVisitConfigActionListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
